/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogState,
} from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { OrderSummaryComponent } from "src/app/features/my-orders/order-summary/order-summary.component";
import { GatewaySelectionComponent } from "src/app/features/payments/gateway-selection/gateway-selection.component";
import { API_PATH } from "../../../environments/config";
import { environment } from "../../../environments/environment";
import { LiveshopService } from "../liveshop/liveshop.service";
import { LocalStorageService } from "../shared/local-storage/local-storage.service";
import { SlotService } from "../slot/slot.service";
declare const Stripe: any;
declare const Razorpay: any;
declare const paypal: any;

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  primaryThemeColor = "#28a4dd";
  stripe;
  isVideoCall;
  userDetails;
  headerData;
  standardTemplate;
  paypalOrderId = "";
  isPaymentWindowOpen = false;
  orderSummaryDialogRef;
  razorpayType = "";
  ordersList = [];
  paymentRetryData;
  isStripeActive;
  isRazorpayActive;
  isPaypalActive;
  isCodActive;
  paymentSuccess = new BehaviorSubject<boolean>(false);
  closeCheckout = new BehaviorSubject<boolean>(false);
  clearCart = false;
  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    private dialog: MatDialog,
    private liveshopService: LiveshopService,
    private slotService: SlotService,
    public localStorageService: LocalStorageService
  ) {}

  // Stripe payment methods
  createStripeSession(paymentData) {
    this.closeCheckout.next(true);
    this.closeCheckout.next(false);
    this.http
      .post<any>(API_PATH.apis.stripePayment, paymentData)
      .subscribe((res) => {
        localStorage.setItem("checkoutId", res.id);
        localStorage.setItem(
          "currentOrderId",
          JSON.stringify(paymentData.orderId)
        );
        localStorage.setItem(
          "primaryThemeColor",
          this.slotService.primaryThemeColor
        );
        localStorage.setItem("primaryFont", this.slotService.primaryFont);
        window.addEventListener("storage", (event) => {
          if (window.localStorage.getItem("paymentSucess")) {
            this.clearCart = !JSON.parse(
              window.localStorage.getItem("paymentSucess")
            );
            this.paymentSuccess.next(true);
            this.paymentSuccess.next(false);
            localStorage.removeItem("paymentSucess");
            window.removeEventListener("storage", () => {});
          }
        });
        window.open(location.origin + "/payment", "_blank");
      });
  }
  createPayment(account) {
    if (!document.getElementById("stripe")) {
      let body = <HTMLDivElement>document.body;
      let script = document.createElement("script");
      script.id = "stripe";
      script.innerHTML = "";
      script.src = "https://js.stripe.com/v3/";
      script.async = true;
      body.appendChild(script);
      script.onload = () => {
        this.stripe = Stripe(environment.config.stripePublicKey, {
          stripeAccount: account,
        });
        let checkoutId = localStorage.getItem("checkoutId");
        this.stripe.redirectToCheckout({ sessionId: checkoutId });
      };
    } else {
      this.stripe = Stripe(environment.config.stripePublicKey, {
        stripeAccount: account,
      });
      let checkoutId = localStorage.getItem("checkoutId");
      this.stripe.redirectToCheckout({ sessionId: checkoutId });
    }
  }
  checkPayment() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set(
      "checkoutId",
      localStorage.getItem("checkoutId")
    );
    return this.http.get<any>(API_PATH.apis.checkPaymentStatus, {
      params: httpParams,
    });
  }
  createStripeAccount(accountId?) {
    let data = {};
    if (accountId) {
      data = { account: accountId };
    }
    this.http.post<any>(API_PATH.apis.stripeAccount, data).subscribe((res) => {
      window.open(res.url);
    });
  }
  checkAccountStatus(account) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("account", account);
    this.http.get<any>(API_PATH.apis.checkStripeStatus).subscribe((res) => {
      console.log("success");
    });
  }

  redirectToRazorpay(razorpayObj, promolinkData?) {
    this.razorpayType = razorpayObj.res.type;
    let options = {
      key:
        this.razorpayType === "route"
          ? environment.config.razorpayPublicKey
          : environment.config.razorpayPartnerPublicKey, // Enter the Key ID generated from the Dashboard
      amount: razorpayObj.res.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "Shopconnect",
      description: "Payment for order " + razorpayObj.data.orderCode[0],
      image: JSON.parse(localStorage.getItem("companyConfig")).whiteshop
        .companyLogo,
      order_id: razorpayObj.res.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      prefill: {
        email: razorpayObj.data.customerEmail,
        contact:
          JSON.parse(localStorage.getItem("user")).dialCode +
          JSON.parse(localStorage.getItem("user")).mobile,
      },
      handler: (response) => {
        this.headerData = {
          status: "Success",
        };
        // webhook should be triggered
        // this.updateOrder(
        //   razorpayObj.data.orderId,
        //   response.razorpay_payment_id,
        //   response.razorpay_order_id
        // );
        this.paymentSuccess.next(true);
        this.paymentSuccess.next(false);
        this.toastrService.success("Payment completed successfully", null, {
          timeOut: 2000,
        });
        localStorage.removeItem("paymentData");
        // window.location.assign(location.origin + "/payment/success");
        if (promolinkData) {
          promolinkData["status"] = this.headerData.status;
        }
        this.openOrderSummary(
          this.isVideoCall,
          this.userDetails,
          "razorpay",
          this.slotService.websitePromolinkCB ? promolinkData : this.headerData,
          this.standardTemplate
        );
        this.isPaymentWindowOpen = false;
      },
      modal: {
        ondismiss: (res) => {
          let razorpayElement = document.getElementsByClassName(
            "razorpay-container"
          )?.[0];
          if (razorpayElement) razorpayElement["style"].display = "none";
          document.getElementById("ws-body").style.overflow = "auto";
          if (!this.isPaymentWindowOpen) {
            if (promolinkData) {
              promolinkData["status"] = this.headerData.status;
            }
            this.openOrderSummary(
              this.isVideoCall,
              razorpayObj.data.userDetails,
              "razorpay",
              this.slotService.websitePromolinkCB
                ? promolinkData
                : this.headerData
            );
          }
        },
      },
      theme: {
        color: this.primaryThemeColor,
      },
    };
    if (this.razorpayType === "partner") {
      options["account_id"] = razorpayObj.res.account;
    }
    let rzp = new Razorpay(options);
    rzp.open();
    rzp.on("payment.failed", (error) => {
      // webhook should be triggered
      // this.updateFailedPayment(razorpayObj.data.orderCode);
      setTimeout(() => {
        this.paymentSuccess.next(true);
        this.paymentSuccess.next(false);
      }, 1000);
      this.isPaymentWindowOpen = false;
      this.headerData = {
        status: "Fail",
      };
    });
  }

  // Razorpay payment methods
  createOrder(data, promolinkData?) {
    this.closeCheckout.next(true);
    this.closeCheckout.next(false);
    this.isPaymentWindowOpen = true;
    let httpParams = new HttpParams();
    httpParams = httpParams.set("orderId", data.orderId);
    if (data.exchangeRate) {
      httpParams = httpParams.set("exchangeRate", data.exchangeRate);
    }
    this.isVideoCall = data.isVideoCall;
    this.userDetails = data.userDetails;
    this.http
      .get<any>(API_PATH.apis.getPaymentOrderId, { params: httpParams })
      .subscribe((res) => {
        console.log(res.id);
        let razorpayObj = {
          res: res,
          data: data,
        };
        if (localStorage.getItem("retryRedirect")) {
          localStorage.setItem("razorpayOrder", JSON.stringify(razorpayObj));
          window.location.assign(location.origin + "/payment");
        } else {
          this.redirectToRazorpay(
            razorpayObj,
            this.slotService.websitePromolinkCB ? promolinkData : null
          );
        }
      });
  }

  /**
   * @description updates order with the paid status and sets the payment id
   * @param orderId order Id created in our system
   * @param paymentId razorpay payment id
   */
  updateOrder(orderId, paymentId, razorOrderId): void {
    // this.paymentSuccess.next(true);
    // this.paymentSuccess.next(false);
    this.http
      .put(API_PATH.apis.updateRazorpayPayment, {
        orderId: orderId,
        paymentid: paymentId,
        razorOrderId: razorOrderId,
        type: this.razorpayType,
      })
      .subscribe(
        (res) => {
          this.toastrService.success("Payment completed successfully", null, {
            timeOut: 2000,
          });
          // window.location.assign(location.origin + "/payment/success");
          this.openOrderSummary(
            this.isVideoCall,
            this.userDetails,
            "razorpay",
            this.headerData,
            this.standardTemplate
          );
          this.isPaymentWindowOpen = false;
        },
        (err) => {
          this.isPaymentWindowOpen = false;
          this.toastrService.error(
            "Order creation failed. Amount will be refunded",
            null,
            {
              timeOut: 2000,
            }
          );
        }
      );
  }

  openOrderSummary(
    isVideoCall,
    userDetails,
    payment?,
    data?,
    standardTemplate?
  ) {
    let summaryDialogConfig = new MatDialogConfig();
    summaryDialogConfig.maxHeight =
      isVideoCall && payment !== "stripe"
        ? "calc((var(--vh, 1vh) * 100) - 3rem)"
        : "calc(var(--vh, 1vh) * 100)";
    summaryDialogConfig.maxWidth = "100%";
    summaryDialogConfig.width = "100%";
    summaryDialogConfig.height =
      isVideoCall && payment !== "stripe"
        ? "calc((var(--vh, 1vh) * 100) - 3rem)"
        : "calc(var(--vh, 1vh) * 100)";
    summaryDialogConfig.position = {
      left: "0",
      top: "0",
    };
    summaryDialogConfig.disableClose = true;
    summaryDialogConfig.hasBackdrop = false;
    summaryDialogConfig.data = {
      userDetails: userDetails,
      isVideoCall: isVideoCall,
      payment: payment,
      data: data,
      standardTemplate: standardTemplate,
    };
    summaryDialogConfig.panelClass = "nvc-overflow-y-auto";

    this.liveshopService.isOrderSummaryOpen.next("opened");
    document.getElementById("ws-body").classList.add("cdk-global-scrollblock");
    this.orderSummaryDialogRef = this.dialog.open(
      OrderSummaryComponent,
      summaryDialogConfig
    );
    this.orderSummaryDialogRef.componentInstance.stripeRetry.subscribe(
      (res) => {
        if (res?.isRetryPayment) {
          localStorage.setItem("retryRedirect", "true");
          this.retryPaymentInit(res?.isMobile);
        }
      }
    );
    this.orderSummaryDialogRef.afterClosed().subscribe((res) => {
      document
        .getElementById("ws-body")
        .classList.remove("cdk-global-scrollblock");
      if (res?.isRetryPayment) {
        this.retryPaymentInit(res?.isMobile, data);
      }
    });
  }
  retryPaymentInit(isMobile?, headerData?) {
    const companyConfig = JSON.parse(localStorage.getItem("companyConfig"));
    this.paymentRetryData = JSON.parse(localStorage.getItem("paymentData"));
    this.localStorageService
      .getCompanyConfig(null, companyConfig?._id)
      .subscribe((payment) => {
        this.isStripeActive = payment.stripe;
        this.isRazorpayActive = payment.razorpay;
        this.isPaypalActive = payment.paypal;
        this.isCodActive = payment.cod;
        this.resetPayment(this.paymentRetryData.orderId).subscribe(
          (res) => {
            let dialogRef = this.dialog.open(GatewaySelectionComponent, {
              width: isMobile ? "100vw" : "30vw",
              minWidth: isMobile ? "100vw" : "30vw",
              height: isMobile ? "100vh" : "70vh",
              minHeight: isMobile ? "100vh" : "70vh",
              maxHeight: isMobile ? "100vh" : "80vh",
              disableClose: true,
              data: payment,
            });
            dialogRef.afterClosed().subscribe((paymentMethod) => {
              if (paymentMethod) {
                if (paymentMethod === "cod") {
                  this.paymentRetryData.orderId.forEach((eachOrderId) => {
                    this.slotService
                      .createCodShipment({ orderId: eachOrderId })
                      .subscribe(
                        (res) => {
                          console.log("success");
                        },
                        (err) => {
                          console.log(err);
                        }
                      );
                  });
                  this.openOrderSummary(
                    false,
                    this.paymentRetryData.userDetails,
                    "cod"
                  );
                } else {
                  let paymentGateway = paymentMethod;
                  if (paymentGateway) {
                    this.paymentRetryData.account =
                      companyConfig[paymentGateway]?.accountId;
                  }
                  this.orderPayment(
                    paymentGateway,
                    this.paymentRetryData,
                    headerData
                  );
                }
              }
            });
          },
          (err) => {}
        );
      });
  }
  orderPayment(paymentGateway, paymentData, headerData?) {
    localStorage.removeItem("checkoutId");
    if (this.isStripeActive && paymentGateway === "stripe") {
      localStorage.removeItem("retryRedirect");
      this.createStripeSession(paymentData);
    } else if (this.isRazorpayActive && paymentGateway === "razorpay") {
      this.createOrder(paymentData, headerData);
    } else {
      this.toastrService.success("Order has been placed successfully", null, {
        timeOut: 2000,
      });
      this.openOrderSummary(false, this.userDetails);
    }
  }

  updateFailedPayment(orderNumber) {
    this.paymentSuccess.next(true);
    this.paymentSuccess.next(false);
    this.http
      .put(API_PATH.apis.updateFailedPayment, { orderId: orderNumber })
      .subscribe((res) => {
        // this.toastrService.error("Payment Failed", null, { timeOut: 3000 });
      });
  }

  closeOrderSummary() {
    if (
      this.orderSummaryDialogRef &&
      this.orderSummaryDialogRef.getState() === MatDialogState.OPEN
    ) {
      document
        .getElementById("ws-body")
        .classList.remove("cdk-global-scrollblock");
      this.orderSummaryDialogRef.close();
    }
  }

  isOrderSummaryStateOpen() {
    return (
      this.orderSummaryDialogRef &&
      this.orderSummaryDialogRef.getState() === MatDialogState.OPEN
    );
  }
  resetPayment(orderId) {
    return this.http.post(API_PATH.apis.resetPayment, { orderId: orderId });
  }
  checkProductAvailability(orderId) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("orderId", orderId);
    return this.http.get<any>(API_PATH.apis.checkProductAvailability, {
      params: httpParams,
    });
  }

  initPaypalButtons() {
    const paymentOptions = {
      // Set your environment
      env: "sandbox",
      fundingSource: paypal.FUNDING.PAYPAL,
      // Set style of button
      style: {
        layout: "vertical", // horizontal | vertical
        size: "responsive", // medium | large | responsive
        shape: "pill", // pill | rect
        color: "gold", // gold | blue | silver | black
      },
      // Execute payment on authorize
      commit: true,
      // Wait for the PayPal button to be clicked
      createOrder: () => {
        console.log(this.paypalOrderId);
        return new Promise((resolve) => {
          this.http
            .post(API_PATH.apis.createPaypalOrder, { orders: this.ordersList })
            .subscribe((res: any) => {
              this.paypalOrderId = res.id;
              resolve(res.id);
            });
        });
      },
      // Wait for the payment to be authorized by the customer
      onApprove: (data, actions) => {
        // Capture Order
        this.http
          .post(API_PATH.apis.capturePaypalOrder, {
            orderId: this.paypalOrderId,
            company: JSON.parse(localStorage.getItem("companyConfig")).owner
              .company,
          })
          .subscribe((res: any) => {
            this.closeCheckout.next(true);
            this.closeCheckout.next(false);
            this.paymentSuccess.next(true);
            this.paymentSuccess.next(false);
            this.openOrderSummary(
              this.isVideoCall,
              this.userDetails,
              "paypal",
              this.headerData,
              this.standardTemplate
            );
            this.isPaymentWindowOpen = false;
          });
        return;
      },
    };
    paypal.Buttons(paymentOptions).render("#paypalCheckoutContainer");
  }
}
